import isFieldVisible from '../selectors/isFieldVisible';

export function hasValue(el) {
  if(el.type === 'checkbox' || el.type === 'radio') {
    return el.checked;
  } else {
    return !!el.value;
  }
}

export function conditionedValue(el) {
  if (el.name === 'phone_number') {
    // unmask phone_number
    return el.value.replace(/[()\-# ]/g, '');
  } else {
    return el.value;
  }
}

// Converts a form's fields into a nice friendly JS object
// Extracted from https://codepen.io/gabrieleromanato/pen/LpLVeQ
export function serialize(form) {
  if (!form || form.nodeName !== 'FORM') {
    return;
  }

  const obj = {};
  const elements = form.querySelectorAll('input, select, textarea');
  [...elements].filter(el => !el.disabled).forEach(function(element) {
    const name = element.name;
    if(name && hasValue(element) && isFieldVisible(element)) {
      obj[name] = conditionedValue(element);
    }
  });

  return obj;
}

export default serialize;



// WEBPACK FOOTER //
// ./client/app/scripts/principles/form/serialize.js